import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const Container = styled.div(() =>
  mq({
    padding: [
      `${defaultTheme.spacing.xxl} 0`,
      `${defaultTheme.spacing.xxl} 0`,
      `40px ${defaultTheme.spacing.xxl}`,
      `40px ${defaultTheme.spacing.xxl}`,
    ],
    '& > div:first-of-type': {
      borderBottom: `1px solid ${defaultTheme.border.color.lightGray}`,
      paddingBottom: [
        defaultTheme.spacing.xxl,
        defaultTheme.spacing.xxl,
        '40px',
        '40px',
      ],
      marginBottom: [
        defaultTheme.spacing.xxl,
        defaultTheme.spacing.xxl,
        '40px',
        '40px',
      ],
    },
  }),
);

export const Wrapper = styled.div(() =>
  mq({
    textAlign: 'center',
    '& > h2': {
      fontSize: [
        defaultTheme.font.size.m,
        defaultTheme.font.size.m,
        defaultTheme.font.size.l,
        defaultTheme.font.size.l,
      ],
      fontWeight: 'bold',
    },
    button: {
      width: ['100%', '100%', '320px', '320px'],
      maxWidth: ['320px', '320px', 'auto', 'auto'],
      height: ['40px', '56px', '56px', '56px'],
      margin: `${defaultTheme.spacing.xxl} auto`,
    },
    '& > p': {
      color: defaultTheme.text.gray,
      fontSize: [
        defaultTheme.font.size.s,
        defaultTheme.font.size.s,
        defaultTheme.font.size.m,
        defaultTheme.font.size.m,
      ],
      a: {
        textDecorationLine: 'underline',
        ...hoverOpacity,
      },
    },
  }),
);

export const ButtonLink = styled.a(() =>
  mq({
    display: 'inline-block',
    width: ['100%', '100%', 'auto', 'auto'],
    maxWidth: ['320px', '320px', 'auto', 'auto'],
  }),
);

export const SpBr = styled.br(() =>
  mq({
    display: ['none', 'none', 'none', 'none'],
  }),
);
